import { NavLink } from 'react-router-dom';
import { DocumentStatus } from '../types';
import IconLoader from '../../icons/loader';
import IconPaper from '../../icons/paper';
import IconSelected from '../../icons/selected';
import IconAttention from '../../icons/attention';
import IconBlock from '../../icons/block';
import IconDownload from '../../icons/download';
import formatDate from '../../../helpers/format-date';
import { DocumentTypes } from './types';

import styles from './documents.module.css';

export default function DocumentItem({
  document,
  downloadInProgress,
  setSubPanelVisible,
  onDownloadDocument,
  setSelectedDocumentName,
  setTransactionSidepanelVisible,
  setSelectedDocumentId,
  getTransactionDocument,
  internal,
  recipientAccount,
  senderAccount,
}: DocumentTypes) {
  let statusIcon: React.JSX.Element;

  if (document.status === DocumentStatus.ACCEPTED) {
    statusIcon = (
      <div className={styles.documentAccepted}>
        <IconSelected
          className={styles.documentStatusIcon}
          height={9}
          width={13}
        />
      </div>
    );
  } else if (document.status === DocumentStatus.EXPIRED) {
    statusIcon = (
      <div className={styles.documentExpired}>
        <IconAttention />
      </div>
    );
  } else if (document.status === DocumentStatus.REJECTED) {
    statusIcon = (
      <div className={styles.documentRejected}>
        <IconBlock />
      </div>
    );
  } else {
    statusIcon = <div className={styles.documentNew} />;
  }

  let organizationLink = '#';

  if (internal) {
    if (document?.organizationId === recipientAccount?.organizationId) {
      if (recipientAccount?.organization?.type === 'INDIVIDUAL') {
        organizationLink = `/customers/individual/${recipientAccount?.organizationId}`;
      } else {
        organizationLink = `/customers/corporate/${recipientAccount?.organizationId}`;
      }
    } else if (document?.organizationId === senderAccount?.organizationId) {
      if (senderAccount?.organization?.type === 'INDIVIDUAL') {
        organizationLink = `/customers/individual/${senderAccount?.organizationId}`;
      } else {
        organizationLink = `/customers/corporate/${senderAccount?.organizationId}`;
      }
    }
  }

  return (
    <div className={styles.documentItem}>
      <div className={styles.documentTop}>
        <button
          type="button"
          className={styles.documentOpenButton}
          onClick={() => {
            setTransactionSidepanelVisible(false);
            setSubPanelVisible(true);
            setSelectedDocumentName(document.name);

            if (getTransactionDocument) {
              getTransactionDocument(document?.id);
            }
          }}
        >
          <IconPaper className={styles.documentIcon} />
          <span>{document.name}</span>
        </button>
        <div className={styles.documentTopRight}>
          <div
            className={`${styles.documentStatus} ${
              document.status === DocumentStatus.NEW
                ? styles.documentStatusNew
                : ''
            } ${
              document.status === DocumentStatus.REJECTED
                ? styles.documentStatusRejected
                : ''
            } ${
              document.status === DocumentStatus.ACCEPTED
                ? styles.documentStatusAccepted
                : ''
            } `}
          >
            <span>
              {document.status}
              {statusIcon}
            </span>
          </div>
          <button
            type="button"
            className={styles.downloadButton}
            onClick={() => {
              if (onDownloadDocument) {
                onDownloadDocument(document.id);
              }

              setSelectedDocumentId(document.id);
            }}
          >
            {downloadInProgress ? (
              <IconLoader width={16} height={16} />
            ) : (
              <IconDownload />
            )}
          </button>
        </div>
      </div>
      <div className={styles.documentBottom}>
        {internal && document?.organizationId && (
          <NavLink
            to={organizationLink}
            className={`${styles.documentDate} ${
              !organizationLink ? styles.organizationLinkDisabled : ''
            } ${styles.organizationLink}`}
            target="_blank"
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {document?.organizationId === recipientAccount?.organizationId
              ? recipientAccount?.organization?.type === 'INDIVIDUAL'
                ? `${recipientAccount?.organization?.firstName} ${recipientAccount?.organization?.lastName}`
                : recipientAccount?.organization?.companyName
              : senderAccount?.organization?.type === 'INDIVIDUAL'
                ? `${senderAccount?.organization?.firstName} ${senderAccount?.organization?.lastName}`
                : senderAccount?.organization?.companyName}
          </NavLink>
        )}
        <div className={styles.documentDate}>
          {formatDate(document.createdAt, true)}
        </div>
      </div>
    </div>
  );
}
